'use client';

import Home from "./sections/home/home";
import Clients from "./sections/clients/clients";
import Features from "./sections/features/features";
import Testimonials from "./sections/testimonials/testimonials";
import Conquests from "./sections/conquests/conquests";
import Integrations from "./sections/integrations/integrations";
import Management from "./sections/management/management";
import Footer from "./sections/footer/footer";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import './intitutional-globals-style.css';
import { LogoWpp } from "../../assets/imgs";
import { useEffect } from "react";

export default function LandingPage() {
  const { height, width } = useWindowDimensions();
  const proportion = width! / height!;
  const whatsappLink = "https://wa.me/5535992256401";
  let contentClass = "content";

  if(height! > width!) {
    contentClass += "-mobile";
  } else if(proportion! <= 1.333) { // 4.3
    contentClass += "-4-3";
  } else if(proportion! <= 1.777) { // 16.9
    contentClass += "-16-9";
  } else { // 21.9
    contentClass += "-21-9";
  }

  useEffect(() => {
    // Inject the Facebook Pixel script
    const script = document.createElement("script");
    script.async = true;
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1285793482889990');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);

    // Add the noscript fallback
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `
      <img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=1285793482889990&ev=PageView&noscript=1" />
    `;
    document.body.appendChild(noscript);

    return () => {
      // Cleanup the script and noscript elements on component unmount
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);

  return (
    <html lang="pt_br">
      <head>
      </head>
      <body className="institutional-body antialiased" >
        <FloatingWhatsApp 
            phoneNumber="+5535992256401"
            accountName="Jornada Sat"
            chatMessage="Olá! Digite sua mensagem aqui e você será redirecionado para um de nossos consultores"
            statusMessage="Soluções inteligentes"
            placeholder="Digite sua mensagem..."
            avatar={LogoWpp}
            allowEsc
            notification />
        <Home  contentClass={contentClass} whatsappLink={whatsappLink}/>
        <Clients  contentClass={contentClass} />
        <Features  contentClass={contentClass} />
        <Testimonials  contentClass={contentClass} />
        <Conquests  contentClass={contentClass} />
        <Integrations  contentClass={contentClass} />
        <Management  contentClass={contentClass} whatsappLink={whatsappLink} />
        <Footer  contentClass={contentClass} />
      </body>
    </html>
  );
}
